import React, { useState, useEffect } from "react";
import "./Rewards_Recognization.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaTimes } from "react-icons/fa";
import { useTranslation } from "react-i18next";

/* IMPORT NEWS IMAGES */
import n1 from "../../Asset/Images/awar2.jpg";
import n2 from "../../Asset/Images/awar6.jpeg";
import n3 from "../../Asset/Images/awar55.jpg";
import n4 from "../../Asset/Images/awar12.jpeg";
import n5 from "../../Asset/Images/awar8.jpeg";
import n6 from "../../Asset/Images/awar0.jpeg";
import n7 from "../../Asset/Images/awa.jpeg";
import n8 from "../../Asset/Images/awar4.jpg";
import n9 from "../../Asset/Images/awar.png";
import n10 from "../../Asset/Images/awar13.jpeg";
import n11 from "../../Asset/Images/awar5.jpg";
import n12 from "../../Asset/Images/awar7.jpeg";
import n13 from "../../Asset/Images/awar11.jpeg";
import n14 from "../../Asset/Images/awar3.jpg";
import n15 from "../../Asset/Images/awar9.jpeg";

const newsImages = [
  n1, n2, n3, n4, n5, n6, n7, n8, n9, n10, n11, n12, n13, n14, n15
];

const RewardsRecognization = () => {

  const { t } = useTranslation();
  const [activeImage, setActiveImage] = useState(null);

  useEffect(() => {
    AOS.init({
      duration: 900,
      once: true
    });
  }, []);

  useEffect(() => {
    if (activeImage) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    return () => { document.body.style.overflow = "auto"; };
  }, [activeImage]);

  return (
    <div className="news_page">

      {/* HEADER */}
      <div className="news_header">

        <h1>
          {t('awards.title_part1')} <span>{t('awards.title_part2')}</span>
        </h1>

        <p>
          {t('awards.subtitle')} <strong>{t('brand.title')}</strong>.
        </p>

      </div>


      {/* GRID */}
      <div className="news_grid">

        {newsImages.map((img, index) => (

          <div
            className="news_card"
            key={index}
            data-aos="zoom-in"
            data-aos-delay={index * 40}
            onClick={() => setActiveImage(img)}
          >

            <img src={img} alt={`award-${index}`} loading="lazy" />

            <div className="news_overlay">
              <button className="open_btn">
                {t('awards.view_detail')}
              </button>
            </div>

          </div>

        ))}

      </div>


      {/* MODAL */}
      {activeImage && (

        <div
          className="news_popup_overlay"
          onClick={() => setActiveImage(null)}
        >

          <button
            className="news_close_fixed"
            onClick={() => setActiveImage(null)}
          >
            <FaTimes />
          </button>

          <div
            className="news_modal_content"
            onClick={(e) => e.stopPropagation()}
          >

            <img src={activeImage} alt="Award Full View" />

          </div>

        </div>

      )}

    </div>
  );
};

export default RewardsRecognization;